import { getEnv } from "config/Config";
import { eaFetch } from "services/common/ApiUtils";

export async function getReferenceData(dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/list`
  );
}

export async function getListCountries(dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/list/countries`
  );
}

export async function getListActivity(level, lang, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/list/activities${level ? "?level=" + level : ""}${level ? "&" : "?"}language=${lang}`
  );
}

export async function getAllTypeDoc(dispatch, accountId, lang) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/list/account/docTypes${lang ? "?language=" + lang : ""}${accountId ? "&accountId=" + accountId : ""}`
  );
}

export async function getListLegalCategoryTranslation(accountId, dispatch, lang) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/list/legal-categories${lang ? "?language=" + lang : ""}`
  );
}

export async function getCollectiveProceedingSteps(dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    '365/list/collectiveProceedingSteps'
  );
}